import { ProtocolContentData } from "../../protocol";
export default class TugEngagedData extends ProtocolContentData {
    name;
    otherActivities;
    freeText;
    positionGeneral;
    positionDetailed;
    pullingSecured;
    constructor(name, positionGeneral, positionDetailed, pullingSecured, otherActivities, freeText) {
        super();
        this.name = name;
        this.otherActivities = otherActivities;
        this.freeText = freeText;
        this.positionGeneral = positionGeneral;
        this.positionDetailed = positionDetailed;
        this.pullingSecured = pullingSecured;
    }
}
//# sourceMappingURL=TugEngagedData.js.map